<template>
    <v-layout justify-center>
        <v-container fluid>
            <v-card-title>
                <v-btn text @click="toTarefaDetalhes()"><v-icon left>add</v-icon>Nova tarefa</v-btn>
            </v-card-title>
            <v-card>
                <v-tabs v-model="tabs">
                    <v-tab :key="1">Pendentes</v-tab>
                    <v-tab :key="2">Todas</v-tab>
                    <template v-for="item in storeProjetos.data">
                        <v-tab>{{item.nome}}</v-tab>
                    </template>
                </v-tabs>
                <v-tabs-items v-model="tabs">
                    <v-tab-item>
                        <v-card>
                            <v-layout column>
                                <v-card-title>
                                    <v-btn text @click="storePendentes.load()"><v-icon left>refresh</v-icon>Atualizar</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Pesquisar"
                                        clearable
                                        single-line
                                    ></v-text-field>
                                </v-card-title>

                                <v-data-table
                                    :headers="computedHeadersPendentes"
                                    :search="search"
                                    :items="storePendentes.data"
                                    :loading="storePendentes.isLoading"
                                    :items-per-page="10"
                                    sort-by="nome"
                                    :footer-props="footerProps"
                                    class="elevation-1"
                                >
                                    <template style="d-flex" v-slot:item="{ item }">
                                        <tr>
                                            <td class="hidden-sm-and-down">{{ item.id }}</td>
                                            <td>{{ item.titulo }}</td>
                                            <td>{{ item.horasEstimadas }}</td>
                                            <td>{{ item.horasRealizadas }}</td>
                                            <td>{{ item.stringData }}</td>
                                            <td>{{ item.strProjetoNome }}</td>
                                            <td class="text-xs-right">
                                                <v-btn icon @click="toTarefaDetalhes(item.id)" text><v-icon medium color="green lighter-4">list_alt</v-icon></v-btn>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-layout>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card>
                            <v-layout column>
                                <v-card-title>
                                    <v-btn text @click="storeTarefas.load()"><v-icon left>refresh</v-icon>Atualizar</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Pesquisar"
                                        clearable
                                        single-line
                                    ></v-text-field>
                                </v-card-title>

                                <v-data-table
                                    :headers="headers"
                                    :search="search"
                                    :items="storeTarefas.data"
                                    :loading="storeTarefas.isLoading"
                                    :items-per-page="10"
                                    sort-by="nome"
                                    :footer-props="footerProps"
                                    class="elevation-1"
                                >
                                    <template style="d-flex" v-slot:item="{ item }">
                                        <tr>
                                            <td class="hidden-sm-and-down">{{ item.id }}</td>
                                            <td>{{ item.titulo }}</td>
                                            <td>{{ item.horasEstimadas }}</td>
                                            <td>{{ item.horasRealizadas }}</td>
                                            <td>{{ item.stringData }}</td>
                                            <td>{{ item.strConcluida }}</td>
                                            <td>{{ item.strProjetoNome }}</td>
                                            <td class="text-xs-right">
                                                <v-btn icon @click="toTarefaDetalhes(item.id)" text><v-icon medium color="green lighter-4">list_alt</v-icon></v-btn>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-layout>
                        </v-card>
                    </v-tab-item>
                    <template v-for="item in storeProjetos.data">
                        <v-tab-item>
                            <Projeto :id="item.id"/>
                        </v-tab-item>
                    </template>
                </v-tabs-items>
            </v-card>
        </v-container>
    </v-layout>
</template>

<script>

import { Store } from '@/utils/Store.js';
import { EventBus } from '@/EventBus';
import Projeto from '@/views/pessoal/Projeto.vue'

export default {
    components: {
        Projeto
    },
    created() {
        this.storeProjetos.load();
        this.storePendentes.load();
        this.storeTarefas.load();
    },
    mounted() {
        EventBus.$on('tarefaInserida', (eventParam) => {
            this.storePendentes.load();
            this.storeTarefas.load();
        });
        EventBus.$on('tarefaAlterada', (eventParam) => {
            this.storePendentes.load();
            this.storeTarefas.load();
        });
        EventBus.$on('tarefaRemovida', (eventParam) => {
            this.storePendentes.load();
            this.storeTarefas.load();
        });
    },
    computed: {
        computedHeadersPendentes() {
            return this.headers.filter((item) => item.somenteAbaTodas !== true);
        }
    },
    data() {
        return {
            storeProjetos: new Store({ url: '/projetos/Projetos', baseParams: {cliente: '', arquivado: false} }),
            storePendentes: new Store({
                url: '/tarefas/Tarefas',
                baseParams: {cliente: '', concluida: false},
                listeners: {
                    load: (storeEl) => {
                        storeEl.allData = storeEl.allData.map((element) => {
                            if (element.projeto) {
                                element.strProjetoNome= element.projeto.nome;
                            }

                            return element;
                        });

                        storeEl.data = JSON.parse(JSON.stringify(storeEl.allData));
                    }
                }
            }),
            storeTarefas: new Store({
                url: '/tarefas/Tarefas',
                baseParams: {cliente: ''},
                listeners: {
                    load: (storeEl) => {
                        storeEl.allData = storeEl.allData.map((element) => {
                            if (element.projeto) {
                                element.strProjetoNome= element.projeto.nome;
                            }

                            element.strConcluida = (element.concluida) ? 'Sim' : 'Não';

                            return element;
                        });

                        storeEl.data = JSON.parse(JSON.stringify(storeEl.allData));
                    }
                }
            }),
            isTrue: true,
            search: '',
            footerProps: {
                itemsPerPageOptions:  [5, 10, 25, { text: 'Todos', value: -1 }],
                itemsPerPageText: 'Registros por pagina'
            },
            headers: [
                { text: 'Id', align: 'left', sortable: false, value: 'id', width: '60', class: 'hidden-sm-and-down' },
                { text: 'Titulo', align: 'left', value: 'titulo' },
                { text: 'Horas Estimadas', align: 'left', value: 'horasEstimadas' },
                { text: 'Horas Realizadas', align: 'left', value: 'horasRealizadas' },
                { text: 'Data', align: 'left', value: 'stringData' },
                { text: 'Concluida', align: 'left', somenteAbaTodas: true, value: 'strConcluida' },
                { text: 'Projeto', align: 'left', value: 'strProjetoNome' },
                { text: '', align: 'center', value: '', width: '60' }
            ],
            tabs: 0
        };
    },
    methods: {
        toTarefaDetalhes(id) {
            EventBus.$emit('showTarefaDetalhes', {
                id: id
            });
        }
    }
}
</script>